<template>
  <div class="module">
    <b-modal header-bg-variant="primary" header-text-variant="white" size="xl" :id="'modal-print-register-' + params.name" centered ok-disabled
             :title="'Печать справочника ' + params.title" cancel-title-html="Закрыть" button-size="sm">

      <div :id="'print-body-' + params.name">
        <table class="table table-bordered table-striped table-12">
          <tbody>
          <tr>
            <template v-for="(thitem, index) in params.fields">
              <th :key="'th' + index" v-if="thitem.print">{{thitem.name}}</th>
            </template>
          </tr>
          <template v-for="(tritem, trindex) in register.list">
            <tr :key="'tr' + trindex">
              <template v-for="(tditem, tdindex) in params.fields">
                <td :key="'td' + tdindex" v-if="tditem.print">{{tritem[tditem.model]}}</td>
              </template>
            </tr>

          </template>
          </tbody>
        </table>
      </div>

      <template v-slot:modal-footer="{cancel}">
        <b-button variant="dark" size="sm" @click="Print('print-body-' + params.name, 'landscape')"><span class="mdi mdi-printer"></span> Печать
        </b-button>
        <b-button variant="secondary" size="sm" @click="cancel()"><span class="mdi mdi-close"></span> Закрыть
        </b-button>
      </template>
    </b-modal>

    <Control :card="false" :icon="params.icon" :title="'Справочник: ' + params.title + ' (' + countItems + ')'" :links="links" :premium="true">
        <SelectOrg v-if="showorg" class="mr-1" :title="['Организация', 'Организация']" :name="'orgs'" :table="'reg_organizations'"
                   :fields="['name']"></SelectOrg>
        <b-button @click="$emit('change','new')" size="sm" variant="primary" class="mr-sm-1"><span
            class="mdi mdi-card-plus"></span> {{ params.addnew }}
        </b-button>

        <b-button size="sm" variant="dark" @click="$bvModal.show('modal-print-register-' + params.name)"><span class="mdi mdi-printer"></span> Печать</b-button>
     </Control>


    <div class="row" v-if="user.registered && !user.subscribe_expired">
        <div class="col-md-12">
          <div v-if="user.subscribe_expired" class="alert alert-danger text-center">Ваши справочники скрыты потому что ваша подписка окончена. Для работы в калькуляторе продлите подписку.
            <a href="/calc/price">Узнать стоимость и условия подписки</a></div>
          <table class="table table-bordered table-hover table-sm">
            <tbody>
            <tr class="bg-light">
              <th></th>
              <template v-for="item in params.fields">
                <th v-if="item.show" v-bind:key="item.id">{{ item.name }}</th>
              </template>
              <th>Действия</th>
            </tr>
            <template v-if="typeof register.list != 'undefined'">

              <template v-for="row in register.list">

                <tr v-if="!row.deleted" v-bind:key="row.id">
                  <td v-if="row.current" class="text-success"><span class="mdi mdi-check"></span></td>
                  <td v-else class="text-success"></td>
                  <template v-for="item in params.fields">
                    <td class="text-success" v-if="item.show" v-bind:key="item.id">
                      <strong v-if="row.current">{{ row[item.model] }}</strong>
                      <span v-else>{{ row[item.model] }}</span>
                    </td>

                  </template>
                  <td>
                                 <span v-for="item in params.task" v-bind:key="item">
                                     <b-button class="mr-1" @click="$emit('change','edit', row.id)" variant="primary" size="sm"
                                               v-if="item == 'edit'"><span
                                         class="mdi mdi-file-document-edit"></span> Редактировать</b-button>
                                     <b-button class="mr-1" @click="$emit('change','delete', row.id)" variant="danger" size="sm"
                                               v-if="item == 'delete'"><span
                                         class="mdi mdi-delete"></span> Удалить</b-button>
                                   <b-button class="mr-1" @click="$emit('change','copy_worker', row.id)" variant="success" size="sm"
                                             v-if="item == 'copy_worker'"><span
                                       class="mdi mdi-content-copy"></span> Копировать/переместить</b-button>


                                 </span>
                  </td>
                </tr>

              </template>


            </template>

            </tbody>
          </table>
          <template v-if="deleted">
            <hr>
            <h4 v-if="params.title"><span class="mdi mdi-delete"></span> Удаленные {{ params.title.toLowerCase() }}</h4>
            <table class="table table-bordered table-hover table-striped table-sm">
              <tbody>

              <tr>
                <th></th>
                <template v-for="item in params.fields">
                  <th v-if="item.show" v-bind:key="item.id">{{ item.name }}</th>
                </template>
                <th>Действия</th>
              </tr>

              <template v-for="row in register.list">
                <tr v-if="row.deleted" v-bind:key="row.id">
                  <td class="text-danger"><span class="mdi mdi-delete"></span></td>
                  <template v-for="item in params.fields">
                    <td class="text-danger" v-if="item.show" v-bind:key="item.id">{{ row[item.model] }}</td>
                  </template>
                  <td class="text-danger">
                    <b-button class="mr-1" @click="$emit('change','erase', row.id)" variant="danger" size="sm"><span
                        class="mdi mdi-eraser"></span> Удалить окончательно
                    </b-button>
                    <b-button @click="$emit('change','restore', row.id)" variant="success" size="sm"><span
                        class="mdi mdi-delete-restore"></span> Восстановить
                    </b-button>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </template>
        </div>
      </div>

    <Premium v-else />


  </div>

</template>


<script>

import SelectOrg from "@/components/base/SelectOrg"
import Control from "@/components/base/ControlPanel"
import Premium from "@/components/base/Premium"
import {mapGetters} from "vuex";

export default {
  name: 'Register',
  components: {
    SelectOrg,
    Control,
    Premium
  },
  props: ['params', 'register', 'showorg', 'links'],

  data: function () {
    return {
      print: {}
    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    }),
    countItems: {
      get() {
        var count = 0;
        if (typeof this.register.list != 'undefined') {
          for (var i = 0; i < this.register.list.length; i++) {
            if (!this.register.list[i].deleted) {
              count++;
            }
          }
        }

        return count
      }
    },
    cols: {
      get() {
        var count = 0;
        if (typeof this.params.fields != 'undefined') {
          for (var i = 0; i < this.params.fields.length; i++) {
            if (!this.params.fields[i].show) {
              count++;
            }
          }
        }

        return count
      }
    },
    deleted: {
      get() {
        let deleted = false
        if (typeof this.register.list !== 'undefined') {
          for (let i = 0; i < this.register.list.length; i++) {
            if (this.register.list[i].deleted) {
              deleted = true;
            }
          }
        }

        return deleted
      }
    }
  }

}
</script>

<style>

</style>
